import React, { Component } from 'react';
import Topnavbar from '../topnavbar/Topnavbar';
import Pagetop from '../Pagetop/Pagetop';
import Footer from '../Footer/Footer';
import AppUrl from '../../restApi/AppUrl';

class AllReportsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      annualReports: [],
      currentPage: 1,
      reportsPerPage: 10,
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    window.scroll(0, 0);
    this.fetchAllReports();
  }

  fetchAllReports = async () => {
    try {
      this.setState({ loading: true });
      const response = await fetch(AppUrl.AnnualReports);
      if (!response.ok) {
        throw new Error('Failed to fetch reports');
      }
      const reports = await response.json();
      this.setState({
        annualReports: reports,
        loading: false
      });
    } catch (error) {
      console.error('Error fetching reports:', error);
      this.setState({
        error: 'Failed to load reports',
        loading: false
      });
    }
  };

  handleDownload = async (report) => {
    try {
      console.log('Starting download for report:', report);
      if (!report.pdf_file) {
        alert('No PDF file available for this report.');
        return;
      }

      // Try direct download first
      try {
        console.log('Attempting direct download...');
        const directDownloadUrl = AppUrl.DownloadAnnualReport + report.id;
        const link = document.createElement('a');
        link.href = directDownloadUrl;
        link.download = `${report.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.pdf`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log('Direct download initiated successfully');
        return;
      } catch (directError) {
        console.log('Direct download failed, trying API method...', directError);
      }

      // Fallback to API method
      const response = await fetch(`${AppUrl.BaseURL}/annual/report/download/${report.id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Download failed with status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success && data.download_url) {
        const link = document.createElement('a');
        link.href = data.download_url;
        link.download = `${report.title.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.pdf`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log('API download initiated successfully');
      } else {
        alert('Download failed: ' + (data.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Error downloading report:', error);
      alert('Download failed. Please try again.');
    }
  };

  goToPage = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
    window.scrollTo(0, 0);
  };

  goBack = () => {
    window.history.back();
  };

  render() {
    const { annualReports, currentPage, reportsPerPage, loading, error } = this.state;

    // Calculate pagination
    const indexOfLastReport = currentPage * reportsPerPage;
    const indexOfFirstReport = indexOfLastReport - reportsPerPage;
    const currentReports = annualReports.slice(indexOfFirstReport, indexOfLastReport);
    const totalPages = Math.ceil(annualReports.length / reportsPerPage);

    if (loading) {
      return (
        <div>
          <Topnavbar title="Annual Reports" />
          <Pagetop title="Annual Reports" />
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            fontSize: '1.2rem',
            color: '#64748b'
          }}>
            Loading reports...
          </div>
          <Footer />
        </div>
      );
    }

    if (error) {
      return (
        <div>
          <Topnavbar title="Annual Reports" />
          <Pagetop title="Annual Reports" />
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            fontSize: '1.2rem',
            color: '#ef4444'
          }}>
            {error}
          </div>
          <Footer />
        </div>
      );
    }

    return (
      <div>
        <Topnavbar title="Annual Reports" />
        <Pagetop title="Annual Reports" />

        <section style={{
          position: 'relative',
          width: '100%',
          padding: '4rem 0',
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          minHeight: '100vh'
        }}>
          {/* Main Container */}
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 2rem',
            position: 'relative',
            zIndex: 10
          }}>

            {/* Header Section */}
            <div style={{
              textAlign: 'center',
              marginBottom: '4rem'
            }}>
              {/* Back Button */}
              <div style={{
                textAlign: 'left',
                marginBottom: '2rem'
              }}>
                <button
                  onClick={this.goBack}
                  style={{
                    background: 'linear-gradient(135deg, #6b7280, #4b5563)',
                    color: 'white',
                    border: 'none',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '50px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    boxShadow: '0 4px 15px rgba(107, 114, 128, 0.3)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
                  }}
                >
                  ← Back to Annual Reports
                </button>
              </div>

              <div style={{
                display: 'inline-block',
                background: 'linear-gradient(135deg, #2E8B54, #237A4B)',
                color: 'white',
                padding: '0.5rem 1.5rem',
                borderRadius: '50px',
                fontSize: '0.875rem',
                fontWeight: '600',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                marginBottom: '1.5rem'
              }}>
                All Annual Reports
              </div>

              <h1 style={{
                fontSize: '3rem',
                fontWeight: '700',
                color: '#1e293b',
                marginBottom: '1.5rem',
                lineHeight: '1.2'
              }}>
                Complete Annual Reports Collection
              </h1>

              <p style={{
                fontSize: '1.125rem',
                color: '#64748b',
                maxWidth: '600px',
                margin: '0 auto',
                lineHeight: '1.7'
              }}>
                Browse and download all our annual reports to see the complete journey of SOYAN's impact and achievements.
              </p>
            </div>

            {/* Reports Grid */}
            <div style={{
              display: 'grid',
              gap: '1rem',
              marginBottom: '3rem'
            }}>
              {currentReports.map((report, index) => (
                <div
                  key={report.id}
                  style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #e2e8f0',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onClick={() => this.handleDownload(report)}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '1rem'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                      flex: 1
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '48px',
                        height: '48px',
                        background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                        borderRadius: '8px',
                        flexShrink: 0
                      }}>
                        📄
                      </div>

                      <div style={{ flex: 1 }}>
                        <h3 style={{
                          fontSize: '1.125rem',
                          fontWeight: '600',
                          color: '#1e293b',
                          marginBottom: '0.5rem'
                        }}>
                          {report.title}
                        </h3>
                        <p style={{
                          fontSize: '1rem',
                          color: '#64748b',
                          lineHeight: '1.6'
                        }}>
                          {report.description}
                        </p>
                      </div>
                    </div>

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '0.75rem 1.5rem',
                      background: 'linear-gradient(135deg, #10b981, #059669)',
                      borderRadius: '8px',
                      color: 'white',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      whiteSpace: 'nowrap',
                      flexShrink: 0
                    }}>
                      ⬇️ Download
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                marginTop: '2rem'
              }}>
                {/* Previous Button */}
                <button
                  onClick={() => this.goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    background: currentPage === 1 ? '#e2e8f0' : 'linear-gradient(135deg, #6b7280, #4b5563)',
                    color: currentPage === 1 ? '#9ca3af' : 'white',
                    border: 'none',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== 1) {
                      e.target.style.transform = 'translateY(-2px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  ← Previous
                </button>

                {/* Page Numbers */}
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    onClick={() => this.goToPage(page)}
                    style={{
                      background: currentPage === page ? 'linear-gradient(135deg, #2E8B54, #237A4B)' : 'white',
                      color: currentPage === page ? 'white' : '#374151',
                      border: currentPage === page ? 'none' : '1px solid #d1d5db',
                      padding: '0.75rem 1rem',
                      borderRadius: '8px',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      minWidth: '40px'
                    }}
                    onMouseEnter={(e) => {
                      if (currentPage !== page) {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    {page}
                  </button>
                ))}

                {/* Next Button */}
                <button
                  onClick={() => this.goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    background: currentPage === totalPages ? '#e2e8f0' : 'linear-gradient(135deg, #6b7280, #4b5563)',
                    color: currentPage === totalPages ? '#9ca3af' : 'white',
                    border: 'none',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    if (currentPage !== totalPages) {
                      e.target.style.transform = 'translateY(-2px)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Next →
                </button>
              </div>
            )}

            {/* Results Info */}
            <div style={{
              textAlign: 'center',
              marginTop: '2rem',
              color: '#64748b',
              fontSize: '0.875rem'
            }}>
              Showing {indexOfFirstReport + 1} to {Math.min(indexOfLastReport, annualReports.length)} of {annualReports.length} reports
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default AllReportsPage;
